/* eslint-disable arrow-body-style */
/* eslint-disable react/no-array-index-key */
import { useKeenSlider } from 'keen-slider/react';
import { useEffect, useState, useRef } from 'react';
import 'keen-slider/keen-slider.min.css';
import cn from 'classnames';
import Image from 'next/image';
import gsap from 'gsap';

import styles from './slider.module.css';

const SectionSlider = ({ images, inverted, bleeds }) => {
  const [mounted, setMounted] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [pause, setPause] = useState(false);
  const timer = useRef();

  const [sliderRef, slider] = useKeenSlider({
    initial: 0,
    centered: true,
    slides: {
      perView: 1,
      spacing: bleeds ? 24 : 0,
    },
    loop: true,
    created(s) {
      s.container.addEventListener("mouseover", () => {
        setPause(true)
      })
      s.container.addEventListener("mouseout", () => {
        setPause(false)
      })
    },
    slideChanged(s) {
      setCurrentSlide(s.track.details.rel);
    },
    dragStarted: () => {
      gsap.to(slider.current.container.querySelectorAll('.keen-slider__slide > div'), {
        scale: 0.9,
        stagger: {
          each: 0.02,
          from: 'start'
        }
      });
      slider.current.container.style.cursor = 'grabbing';
    },
    dragEnded: () => {
      gsap.to(slider.current.container.querySelectorAll('.keen-slider__slide > div'), {
        scale: 1,
        stagger: {
          each: 0.02,
          from: 'start'
        }
      });
      slider.current.container.style.cursor = 'grab';
    }
  });

  const currentImage = images[currentSlide];

  useEffect(() => {
    if (slider && !mounted) {
      slider.current.update();
      setMounted(true);
    }
  }, [slider, mounted]);

  useEffect(() => {
    timer.current = setInterval(() => {
      if (!pause && slider) {
        slider.current?.next();
      }
    }, 3000);
    return () => {
      clearInterval(timer.current);
    };
  }, [pause, slider]);

  return (
    <div
      className={cn('relative', styles.container, {
        [styles.inverted]: inverted,
        [styles.bleeds]: bleeds
      })}
    >
      <div
        className={cn('relative overflow-hidden', {
          'rounded-3xl xl:rounded-l-3xl': inverted,
          'rounded-3xl xl:rounded-r-3xl': !inverted
        })}
      >
        <div>
          {images && (
            <div ref={sliderRef} className="keen-slider">
              {images.map((img, idx) => {
                return (
                  <div
                    className={cn(' relative overflow-hidden text-center keen-slider__slide', {
                      'xl:pr-0 ': bleeds,
                      'px-10': !bleeds
                    })}
                    style={{ cursor: 'grab' }}
                    key={idx}
                  >
                    <div className="flex w-full overflow-hidden bg-black shadow-lg rounded-3xl">
                      <Image
                        src={img.src}
                        width={1948}
                        height={1530}
                        alt={img.epigraph || 'Logo'}
                        quality="100"
                        priority
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
      {images && slider && (
        <div className={cn('max-w-3xl mx-auto flex justify-center mt-4')}>
          {images.length > 1 && (
            <span
              className="mr-4 transition-opacity cursor-pointer select-none hover:opacity-50"
              onClick={e => e.stopPropagation() || slider.current?.prev()}
            >
              ←
            </span>
          )}
          {currentImage.epigraph && (
            <p className="w-full text-center sm:w-1/2">{currentImage.epigraph}</p>
          )}
          {images.length > 1 && (
            <span
              className="ml-4 transition-opacity cursor-pointer select-none hover:opacity-50"
              onClick={e => e.stopPropagation() || slider.current?.next()}
            >
              →
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default SectionSlider;
